import { motion, AnimatePresence } from 'framer-motion';

/** Vinheta suave que puxa o olhar para o canto do QR — não cobre o código. */
export default function QrSpotlightVignette({ ativo }: { ativo: boolean }) {
  return (
    <AnimatePresence>
      {ativo && (
        <motion.div
          className="fixed inset-0 z-[12] pointer-events-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45 }}
          aria-hidden
          style={{
            background: [
              'radial-gradient(ellipse 38% 32% at 9% 9%, rgba(249,115,22,0.22) 0%, transparent 72%)',
              'radial-gradient(ellipse 120% 90% at 50% 50%, transparent 35%, rgba(0,0,0,0.42) 100%)',
            ].join(', '),
          }}
        />
      )}
    </AnimatePresence>
  );
}
